// extracted by mini-css-extract-plugin
export default {"terms":"Signup_terms__oSSJd"};